


















































import Vue from "vue";
import AdminService from "@/services/adminService";

export default Vue.extend({
  name: "UploadAgreement",

  data() {
    let tmp: any;
    return {
      file: tmp,
      uploading: false,
      name: "",
      lastname: "",
      title: "",
      email: "",
      mobile: "",
      certification: "",

    };
  },
  methods: {
    handleFileUpload(e) {
      this.file = e.target.files[0]
    },
    async submit(e) {
      this.uploading = true;
      e.preventDefault();
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          formData.append("name", this.name);
          formData.append("lastname", this.lastname);
          formData.append("title", this.title);
          formData.append("email", this.email);
          formData.append("mobile", this.mobile);
          formData.append("certification", this.certification);
          const adminService = new AdminService(jwt);
          const response = await adminService.createTeams(formData);
          if (response && response.status == 200) {
            if (response.data) {
              this.uploading = false;
              alert("Create Successfully");
              await this.$router.push("/admin-teams");
            }
          }
        } catch (error) {
          this.uploading = false;
          alert(JSON.stringify(error.response.data));
        }
      }
    },
    async cancel() {
      await this.$router.push("/admin-teams");
    }
  }
});
